// extracted by mini-css-extract-plugin
module.exports = {"main_black":"#23335B","title":"styles_title__35FU1","sub_title":"styles_sub_title__3396u styles_title__35FU1"};